export class CommPlanDetail {

    public id: number;
    public commPlanId: number;
    public comm_plan_dtl_id: number;
    public cdtr_id: number;
    public comm_plan_id: number;
    public comm_plan: string;
    public kpi_id: number;
    public kpi_name: string;
    public kpi_type: string;
    public kpi_weightage: any;
    public display_flg: string;
    public comm_pool: any;
    public rangeLow: any;
    public range_high: any;
    public modifier_percent: any;
    public commission_val: any;
    public created_dt: Date;
    public created_by: string;
    public update_dt: Date;
    public updated_by: string;
    public tier: string;
    public target: any;
    public display_name: string;
    public measure_type: string;
    public effective_date: Date;
    public isRange: boolean;
    public isTier: boolean;
    public isTarget: boolean;
    public isModifyPercent: boolean;
    public isCommVal: boolean;
    public viewOrder: number;
    public kpi_goal: number;
    public charge_back: string;
    public charge_back_days: number;
    public non_charge_back_days: number;
    public measure_against: any;
    public is_percentage: any;
    public calculate_commission: any;
    // public is_pooled: any;
    public charge_back_type: any;
    public trans_field_value: string;
    public trans_field_name: string;
    public field_short_name: string;
    public operation: string;
    public is_calc_vars: boolean;
    public is_score_vars: boolean;
    public calc_vars_row_level: string;
    public commission_payout: string;
    public colorcode: string;
    public comm_img_str: string;
    public commplan_rowid: any;
    public roll_up_hierarchy: string;

    public kpi_order: any;
    public kpi_weight: any;

    public calc_vars_count: string;
    public calc_vars_score: string;
    public calc_vars_revenue: string;

    public calc_id: string;
    public calc_kpi_goal: string;
    public calc_kpi_id: string;
    public calc_kpi_name: string;
    public calc_kpi_order: string;
    public calc_kpi_weight: string;
    public calc_operation: string;
    public calc_updated_by: string;
    public calc_created_by: string;



    public score_kpiname: string = "NA";
    public score_kweight: string = "NA";
    public score_created: string = "NA";
    public score_kpiids: string = "NA";



    constructor() {
        this.score_kpiname = null;
        this.score_kweight = null;
        this.score_created = null;
        this.score_kpiids = null;
      

        this.calc_id = null;
        this.calc_kpi_goal = null;
        this.calc_kpi_id = null;
        this.calc_kpi_name = null;
        this.calc_kpi_order = null;
        this.calc_kpi_weight = null;
        this.calc_operation = null;
        this.calc_updated_by = null;
        this.calc_created_by = null;
      
        this.kpi_order = null;
        this.kpi_weight = null;
        this.roll_up_hierarchy = null;
        this.commplan_rowid = null;
        this.comm_img_str = null;
        this.colorcode = null;
        this.id = null;
        this.commPlanId = 0;
        this.comm_plan_dtl_id = 0;
        this.cdtr_id = 0;
        this.comm_plan_id = 0;
        this.comm_plan = "";
        this.kpi_id = 0;
        this.kpi_name = "";
        this.kpi_type = "";
        this.kpi_weightage = null;
        this.display_flg = "";
        this.comm_pool = null;
        this.rangeLow = null;
        this.range_high = null;
        this.modifier_percent = null;
        this.commission_val = null;
        this.created_dt = new Date;
        this.created_by = "";
        this.update_dt = new Date;
        this.updated_by = "";
        this.tier = "";
        this.target = null;
        this.display_name = "";
        this.measure_type = "";
        this.effective_date = new Date;
        this.isRange = false;
        this.isTier = false;
        this.isTarget = false;
        this.isModifyPercent = false;
        this.isCommVal = false;
        this.viewOrder = 0;
        this.kpi_goal = 0;
        this.charge_back = "";
        this.charge_back_days = 0;
        this.non_charge_back_days = 0;
        this.measure_against = null;
        this.is_percentage = null;
        this.calculate_commission = null;
        // this.is_pooled = null;
        this.charge_back_type = null;
        this.trans_field_value = null;
        this.trans_field_name = null;
        this.operation = null;
        this.calc_vars_count = null;
        this.calc_vars_score = null;
        this.calc_vars_revenue = null;
        this.is_calc_vars = null;
        this.is_score_vars = null;
        this.calc_vars_row_level = "N";
        this.commission_payout = null;
    }
}
